import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 5%;
  position: relative;
  z-index: 100; /* Ensure header stays on top of other elements */
`;

const LogoLink = styled(Link)`
  text-decoration: none;
  display: block;
`;

const LogoImage = styled.img`
  height: 50px;
  width: auto;
`;

const Navigation = styled.nav`
  display: flex;
  align-items: center;
  gap: 2rem;
`;

const NavLink = styled(Link)`
  text-decoration: none;
  color: #333;
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.2s ease;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #0077cc;
    transition: width 0.2s ease;
  }

  &:hover {
    color: #0077cc;
    
    &:after {
      width: 100%;
    }
  }
  
  &.active {
    color: #0077cc;
    
    &:after {
      width: 100%;
    }
  }
`;

const ContactButton = styled(Link)`
  display: inline-block;
  background-color: #0077cc;
  color: white;
  font-weight: 600;
  font-size: 1rem;
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  text-decoration: none;
  transition: all 0.2s ease;
  box-shadow: 0 4px 6px rgba(0, 119, 204, 0.1);
  
  &:hover {
    background-color: #0066b3;
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(0, 119, 204, 0.2);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 4px 6px rgba(0, 119, 204, 0.1);
  }
`;

const Header = () => {
  const currentPath = window.location.pathname;
  
  return (
    <HeaderContainer>
      <LogoLink to="/">
        <LogoImage 
          src={`${process.env.PUBLIC_URL}/logo-light-background.png`}
          alt="Roaring Bots Logo" 
        />
      </LogoLink>
      <Navigation>
        <NavLink to="/about" className={currentPath === "/about" ? "active" : ""}>
          About
        </NavLink>
        <ContactButton to="/contact">
          Get in Touch
        </ContactButton>
      </Navigation>
    </HeaderContainer>
  );
};

export default Header;